import { type PopupProps, Popup } from '@CS/components/Popups';
import LocalizedImage from '@CS/components/LocalizedImage';
import type { Quiz } from '@/services/api/types';
import { useTranslation } from '@CS/hooks';
import Button from '@CS/components/Button';
import CSS from './Timeout.module.css';
import Images from '@/assets/images';
import { useState } from 'react';
import Content from './content';

type TimeoutProps = PopupProps & {
  last?: boolean;
  quiz: Quiz;
};

export const Timeout = ({ quiz, last, ...props }: TimeoutProps) => {
  const [close, setClose] = useState(false);
  const onClick = () => setClose(true);
  const { title, next, complete } = useTranslation(Content);
  const button = last && complete || next;

  return (
    <Popup
      hideClose
      {...props}
      opacity="0"
      close={close}
      className={CSS.timeoutContainer}
    >
      <LocalizedImage name="Time's Up!" images={Images.Timeout} />

      <div className={CSS.timeoutContent}>
        <h4>{title}</h4>
        <Button text={button} onClick={onClick} />
      </div>
    </Popup>
  );
};
